// Safe Life — catálogo de produtos

export const insuranceTypes = [
  {
    slug: "auto",
    name: "Seguro Auto",
    short: "Auto",
    icon: "fa-car-side",
    tagline: "Proteja seu carro com cobertura completa e franquia reduzida.",
    description:
      "Cobertura para colisão, roubo, furto, incêndio, terceiros (RCF-V), assistência 24h, carro reserva e vidros. Opções mensais, com ou sem rastreador.",
    benefits: [
      "Até 100% da Tabela FIPE em caso de perda total",
      "Bônus progressivo",
      "Carro reserva opcional (até 15 dias)",
      "Assistência 24h: guincho, chaveiro, troca de pneus",
      "Cobertura para terceiros (RCF-V) com limites amplos",
      "Programa de desconto para motoristas seguros (telemetria)"
    ],
    providers: ["Porto Seguro", "Tokio Marine", "Grupo HDI", "Suhai", "Ituran"],
    quoteFields: [
      { name: "plate", label: "Placa do veículo", type: "text", required: false, placeholder: "ABC1D23" },
      { name: "brand_model", label: "Marca e modelo", type: "text", required: true, placeholder: "Honda Civic EXL" },
      { name: "year", label: "Ano do veículo", type: "number", required: true, placeholder: "2021" },
      { name: "zip_code", label: "CEP de pernoite", type: "text", required: true, placeholder: "15706-077" },
      { name: "usage", label: "Uso do veículo", type: "select", required: true, options: ["Particular", "Trabalho", "Uber/99/Aplicativo", "Comercial"] },
      { name: "has_garage", label: "Guarda em garagem?", type: "select", required: false, options: ["Sim, à noite", "Sim, o dia todo", "Não"] }
    ]
  },
  {
    slug: "moto",
    name: "Seguro Moto",
    short: "Moto",
    icon: "fa-motorcycle",
    tagline: "Sua moto protegida contra roubo, furto e imprevistos.",
    description:
      "Proteção especializada para motocicletas — aceitamos motos de todas as cilindradas, inclusive esportivas e customizadas. Assistência 24h em todo o Brasil.",
    benefits: [
      "Indenização integral por roubo ou furto",
      "Assistência 24h: guincho até 500 km, chaveiro",
      "Pagamento em até 12x sem comprometer o limite do cartão",
      "Aceitação ampla (todas as cilindradas)",
      "Cobertura para RCF-V opcional"
    ],
    providers: ["Suhai", "Ituran", "Tokio Marine", "Porto Seguro"],
    quoteFields: [
      { name: "plate", label: "Placa", type: "text", required: false },
      { name: "brand_model", label: "Marca e modelo", type: "text", required: true, placeholder: "Honda CB 500F" },
      { name: "year", label: "Ano", type: "number", required: true },
      { name: "cc", label: "Cilindrada (cc)", type: "number", required: false, placeholder: "500" },
      { name: "zip_code", label: "CEP de pernoite", type: "text", required: true },
      { name: "usage", label: "Uso", type: "select", required: true, options: ["Particular", "Trabalho", "Delivery/App", "Esporte/Lazer"] }
    ]
  },
  {
    slug: "residencial",
    name: "Seguro Residencial",
    short: "Residencial",
    icon: "fa-house-chimney",
    tagline: "Proteja seu lar contra incêndio, roubo e danos elétricos.",
    description:
      "Cobertura completa para casas e apartamentos — incêndio, explosão, desabamento, raios, roubo, furto qualificado, danos elétricos e responsabilidade civil familiar.",
    benefits: [
      "Assistência 24h: chaveiro, encanador, eletricista, vidraceiro",
      "Cobertura para danos elétricos em eletrodomésticos",
      "Proteção contra roubo e furto qualificado",
      "Responsabilidade civil familiar incluída",
      "Cobertura para equipamentos de energia solar: proteção para sistemas fotovoltaicos residenciais, incluindo placas solares, inversores e componentes do sistema, conforme aceitação e condições da seguradora.",
      "Opção de cobertura para pets"
    ],
    providers: ["Porto Seguro", "Grupo HDI", "Allianz"],
    quoteFields: [
      { name: "property_type", label: "Tipo de imóvel", type: "select", required: true, options: ["Casa", "Apartamento", "Sobrado", "Cobertura"] },
      { name: "property_value", label: "Valor estimado do imóvel (R$)", type: "number", required: true, placeholder: "350000" },
      { name: "contents_value", label: "Valor dos bens dentro do imóvel (R$)", type: "number", required: false, placeholder: "50000" },
      { name: "zip_code", label: "CEP do imóvel", type: "text", required: true },
      { name: "occupation", label: "Ocupação do imóvel", type: "select", required: false, options: ["Habitual (residência principal)", "Veraneio", "Fechado (mais de 30 dias/ano)"] }
    ]
  },
  {
    slug: "vida",
    name: "Seguro de Vida",
    short: "Vida",
    icon: "fa-heart-pulse",
    tagline: "Segurança financeira para quem você ama.",
    description:
      "Proteção para sua família em caso de morte, invalidez ou doenças graves. Capital segurado personalizado conforme o momento de vida.",
    benefits: [
      "Capital segurado por morte natural ou acidental",
      "Cobertura para invalidez permanente total e parcial",
      "Indenização para doenças graves (câncer, AVC, infarto)",
      "Assistência funeral familiar",
      "Sorteios mensais (em alguns planos)",
      "Resgate de valores em alguns produtos"
    ],
    providers: ["Porto Seguro", "Allianz", "Tokio Marine"],
    quoteFields: [
      { name: "birth_date", label: "Data de nascimento", type: "date", required: true },
      { name: "profession", label: "Profissão", type: "text", required: true, placeholder: "Engenheiro civil" },
      { name: "desired_capital", label: "Capital desejado (R$)", type: "number", required: true, placeholder: "500000" },
      { name: "smoker", label: "Fumante?", type: "select", required: true, options: ["Não", "Sim"] },
      { name: "dependents", label: "Possui dependentes?", type: "select", required: false, options: ["Sim, cônjuge", "Sim, filhos", "Sim, cônjuge e filhos", "Não"] }
    ]
  },
  {
    slug: "empresarial",
    name: "Seguro Empresarial",
    short: "Empresarial",
    icon: "fa-building-columns",
    tagline: "Proteção completa para o patrimônio do seu negócio.",
    description:
      "Cobertura multirrisco para pequenos e médios negócios: incêndio, roubo, vendaval, equipamentos eletrônicos, lucros cessantes e responsabilidade civil operacional.",
    benefits: [
      "Cobertura de incêndio, explosão e vendaval",
      "Roubo e furto qualificado de mercadorias",
      "Equipamentos eletrônicos (fixos e portáteis)",
      "Lucros cessantes por sinistro coberto",
      "Responsabilidade civil operacional",
      "Assistência 24h empresarial"
    ],
    providers: ["Porto Seguro", "Tokio Marine", "Grupo HDI", "Allianz"],
    quoteFields: [
      { name: "cnpj", label: "CNPJ", type: "text", required: true, placeholder: "00.000.000/0001-00" },
      { name: "business_type", label: "Ramo de atividade", type: "text", required: true, placeholder: "Comércio varejista de vestuário" },
      { name: "annual_revenue", label: "Faturamento anual (R$)", type: "number", required: false, placeholder: "1200000" },
      { name: "zip_code", label: "CEP do estabelecimento", type: "text", required: true },
      { name: "area_m2", label: "Área do imóvel (m²)", type: "number", required: false }
    ]
  },
  {
    slug: "viagem",
    name: "Seguro Viagem",
    short: "Viagem",
    icon: "fa-plane-departure",
    tagline: "Viaje tranquilo — cobertura mundial em saúde e bagagem.",
    description:
      "Proteção para viagens nacionais e internacionais: despesas médicas e hospitalares, extravio de bagagem, cancelamento de viagem e muito mais.",
    benefits: [
      "Despesas médicas e hospitalares (DMH) até USD 250.000",
      "Extravio definitivo de bagagem",
      "Cancelamento e interrupção de viagem",
      "Assistência jurídica no exterior",
      "Telemedicina 24h",
      "Cobertura para esportes de aventura (opcional)"
    ],
    providers: ["Porto Seguro", "Allianz", "Tokio Marine"],
    quoteFields: [
      { name: "destination", label: "Destino principal", type: "text", required: true, placeholder: "Europa (Schengen)" },
      { name: "departure_date", label: "Data de ida", type: "date", required: true },
      { name: "return_date", label: "Data de volta", type: "date", required: true },
      { name: "travelers", label: "Nº de viajantes", type: "number", required: true, placeholder: "2" },
      { name: "has_elderly", label: "Algum viajante com 70+ anos?", type: "select", required: false, options: ["Não", "Sim"] }
    ]
  },
  {
    slug: "frota",
    name: "Seguro de Frota",
    short: "Frota",
    icon: "fa-truck-fast",
    tagline: "Gestão e proteção inteligente para sua frota.",
    description:
      "Solução corporativa com apólice única, gestão centralizada e condições especiais para frotas de 4 ou mais veículos. Telemetria opcional para redução de prêmio.",
    benefits: [
      "Apólice única para toda a frota",
      "Descontos progressivos por volume",
      "Telemetria e relatórios de direção (opcional)",
      "Assistência 24h nacional",
      "Gestão centralizada no painel do cliente"
    ],
    providers: ["Porto Seguro", "Tokio Marine", "Suhai", "Grupo HDI"],
    quoteFields: [
      { name: "cnpj", label: "CNPJ da empresa", type: "text", required: true },
      { name: "fleet_size", label: "Quantidade de veículos", type: "number", required: true, placeholder: "10" },
      { name: "vehicle_types", label: "Tipos predominantes", type: "select", required: false, options: ["Passeio", "Utilitários leves", "Caminhões", "Mista"] },
      { name: "annual_km", label: "Km médio anual por veículo", type: "number", required: false }
    ]
  },
  {
    slug: "condominio",
    name: "Seguro Condomínio",
    short: "Condomínio",
    icon: "fa-building",
    tagline: "Proteção obrigatória para a área comum do seu condomínio.",
    description:
      "Seguro obrigatório por lei (Código Civil) para áreas comuns: incêndio, explosão, vendaval, responsabilidade civil do síndico, portões automáticos.",
    benefits: [
      "Cobertura básica obrigatória (incêndio, explosão)",
      "Danos elétricos em elevadores e portões",
      "Responsabilidade civil do síndico",
      "Assistência 24h para áreas comuns",
      "Cobertura para tubulações e vazamentos"
    ],
    providers: ["Porto Seguro", "Allianz", "Grupo HDI"],
    quoteFields: [
      { name: "cnpj", label: "CNPJ do condomínio", type: "text", required: true },
      { name: "units", label: "Número de unidades", type: "number", required: true, placeholder: "40" },
      { name: "common_area_value", label: "Valor da área comum (R$)", type: "number", required: false, placeholder: "5000000" },
      { name: "has_elevator", label: "Possui elevador?", type: "select", required: false, options: ["Sim", "Não"] }
    ]
  },
  {
    slug: "rastreador",
    name: "Rastreador com Seguro",
    short: "Rastreador + Seguro",
    icon: "fa-satellite-dish",
    tagline: "Monitoramento 24h + proteção veicular com mensalidade acessível.",
    description:
      "Combinação de rastreador veicular com proteção contra roubo e furto. Ideal para quem busca custo-benefício e tecnologia de ponta, com a líder em recuperação no Brasil.",
    benefits: [
      "Monitoramento 24h via satélite",
      "9 em cada 10 veículos recuperados",
      "App para acompanhar o veículo em tempo real",
      "Cobertura contra roubo e furto",
      "Instalação gratuita na rede credenciada",
      "Pagamento mensal (sem entrada)"
    ],
    providers: ["Ituran"],
    quoteFields: [
      { name: "plate", label: "Placa", type: "text", required: false },
      { name: "brand_model", label: "Marca e modelo", type: "text", required: true },
      { name: "year", label: "Ano", type: "number", required: true },
      { name: "zip_code", label: "CEP de pernoite", type: "text", required: true }
    ]
  }
];

export function findInsuranceBySlug(slug) {
  return insuranceTypes.find((i) => i.slug === slug);
}

// Seguradoras parceiras — nome, cor da marca e logo
// Usa favicon HD do Google (estável, disponível para qualquer domínio) com fallback estilizado
const googleLogo = (domain) => `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;

export const partnerInsurers = [
  {
    name: "Porto Seguro",
    color: "#0066B3",
    domain: "portoseguro.com.br",
    logoUrl: googleLogo("portoseguro.com.br"),
  },
  {
    name: "Tokio Marine",
    color: "#DC0F22",
    domain: "tokiomarine.com.br",
    logoUrl: googleLogo("tokiomarine.com.br"),
  },
  {
    name: "Grupo HDI",
    color: "#00A19A",
    domain: "hdiseguros.com.br",
    logoUrl: googleLogo("hdiseguros.com.br"),
  },
  {
    name: "Allianz",
    color: "#003781",
    domain: "allianz.com.br",
    logoUrl: googleLogo("allianz.com.br"),
  },
  {
    name: "Suhai",
    color: "#00A859",
    domain: "suhaiseguradora.com",
    logoUrl: googleLogo("suhaiseguradora.com"),
  },
  {
    name: "Ituran",
    color: "#E30613",
    domain: "ituran.com.br",
    logoUrl: googleLogo("ituran.com.br"),
  },
];

export const COMPANY = {
  name: "Safe Life Corretora de Seguros",
  cnpj: "32.299.728/0001-52",
  susep: "261177097",
  whatsapp: "11964436210", // numbers only for wa.me
  whatsappDisplay: "(11) 96443-6210",
  email: "contato@safelifeseguros.com.br",
  address: "Rua Otavio Graziani, nº 1034, Sala 3, Jardim Oiti - Jales/SP",
  zipCode: "15.706-077",
  logoUrl: "https://customer-assets.emergentagent.com/job_insurance-quote-3/artifacts/p1osjtvg_WhatsApp%20Image%202026-04-19%20at%2022.39.05.jpeg",
};
